import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage, getFormattedDate } from "helpers";
import { paymentsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

export type usePayoutsListQueryProps = {
	paidMonth: Date | string;
	paidYear: Date | string;
	fetchData: { page: number; filters: any; sortBy: { [key: string]: any } };
};

const usePayoutsListQuery = ({
	fetchData,
	paidMonth,
	paidYear,
}: usePayoutsListQueryProps) => {
	const dispatch = useDispatch();

	const { page, filters, sortBy } = fetchData;

	const valueDate = getFormattedDate({
		date: filters?.valueDate,
		format: "yyyy-MM-DD",
	});

	const fetchPayoutsList = () =>
		paymentsService.getPayoutsLists({
			paidMonth,
			paidYear,
			valueDate,
			page,
			filters,
			sortBy,
		});

	const queryResult = useQuery(
		["agentPayouts", page, filters, sortBy],
		fetchPayoutsList,
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			retry: false,
			keepPreviousData: true,
			enabled: !!(paidMonth && paidYear),
		},
	);

	return queryResult;
};

export default usePayoutsListQuery;
